export default "__VITE_ASSET__CvL1FUXV__"